import { validatePhoneNumber } from '../utils/helpers';
import { getTechnicalData } from '../utils/storefront/format-resource';

// eslint-disable-next-line func-names
window.smsBumpSubscribe ||= function (formId, phone, source) {
  const smsbumpRequest = {
    form_id: formId,
    phone,
    accepts_marketing: true,
    email: '',
    email_consent: false,
  };

  if (source) {
    smsbumpRequest.source = source;
  }
  if (smsbumpRequest.phone.length) {
    const smsbXhr = new XMLHttpRequest();
    smsbXhr.open('POST', 'https://api.smsbump.com/v2/formsPublic/subscribe');
    smsbXhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    smsbXhr.setRequestHeader('X-SMSBump-Platform', 'shopify');
    smsbXhr.onload = () => {
      if (smsbXhr.status === 200) {
        const subscriptionEvent = new CustomEvent('smsbump-success');
        window.dispatchEvent(subscriptionEvent);
      } else if (smsbXhr.status !== 200) {
        const subscriptionEvent = new CustomEvent('smsbump-error');
        window.dispatchEvent(subscriptionEvent);
      }
    };
    let query = encodeURI(
      // eslint-disable-next-line max-len
      `form_id=${smsbumpRequest.form_id}&phone=${smsbumpRequest.phone}&accepts_marketing=${smsbumpRequest.accepts_marketing}&email=${smsbumpRequest.email}&email_consent=${smsbumpRequest.email_consent}`,
    );
    if (smsbumpRequest.source) {
      query += `&source=${smsbumpRequest.source}`;
    }
    smsbXhr.send(query);
  }
};

const YotpoSMS = async () => {
  const inputFormWrapper = document.querySelector('[data-sms-form]');
  const inputWrapper = inputFormWrapper.querySelector('domaine-input[data-input]');
  const formInput = inputFormWrapper.querySelector('input[type="tel"]');
  const checkBoxWrapper = inputFormWrapper.querySelector('domaine-input[data-checkbox]');
  const checkBoxInput = inputFormWrapper.querySelector('input[type=checkbox]');
  inputWrapper.removeAttribute('error');
  checkBoxWrapper.removeAttribute('error', '');

  window.addEventListener('smsbump-success', () => {
    inputFormWrapper.setAttribute('success', '');
    formInput.value = '';

    setTimeout(() => {
      inputFormWrapper.removeAttribute('success');
    }, 3000);
  });

  window.addEventListener('smsbump-error', () => {
    inputWrapper.errorText = window.TMW.Strings.general.forms.submitError.generic;
    inputWrapper.setAttribute('error', '');
  });

  try {
    const inputValue = formInput.value.replace(/\D/g, '');

    if (checkBoxInput && !checkBoxInput.checked) {
      inputWrapper.errorText = window.TMW.Strings.general.forms.submitError.optInRequired;
      checkBoxWrapper.setAttribute('error', '');
      throw new Error(window.TMW.Strings.general.forms.submitError.optInRequired);
    }

    if (inputValue.trim().length === 0 || validatePhoneNumber(inputValue) === false) {
      inputWrapper.errorText = window.TMW.Strings.general.forms.submitError.phone;
      throw new Error(window.TMW.Strings.general.forms.submitError.phone);
    }

    const yotpoSMSListID = getTechnicalData('yotpoSMSListId');
    if (!yotpoSMSListID) return;

    window.smsBumpSubscribe(yotpoSMSListID, inputValue.trim());
  } catch (error) {
    // eslint-disable-next-line no-console
    inputWrapper.setAttribute('error', '');
  }
};

export default YotpoSMS;
